import axios from 'axios';

// Same-origin: nginx proxies /api to the API and adds the Authorization header
// server-side (see docker/default.conf), so no token is shipped to the browser.
//
// Calling https://app.thefeedfactory.nl/api directly does not work from a
// browser: that host sends no Access-Control-Allow-Origin, so every response is
// blocked by CORS no matter which token is used.
export const feedFactoryAxios = axios.create({
  baseURL: '/api',
});

export const setAuthToken = (token: string) => {
  feedFactoryAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};
